import { useEffect, useRef } from 'react';
import { useFormState } from 'react-final-form';
import { isString } from 'lodash';
import { App } from 'antd';

/**
 * SubmitErrorToast
 *
 * Shows an AntD toast whenever a submit finishes with an error.
 * - Subscribes only to submit-related meta to avoid firing on normal input changes.
 * - Detects the transition submitting: true -> false to show exactly once per submit.
 */
const SubmitErrorToast = () => {
  const { message } = App.useApp();
  const { submitting, submitFailed, submitError } = useFormState({
    subscription: { submitting: true, submitFailed: true, submitError: true },
  });

  const wasSubmitting = useRef(false);

  useEffect(() => {
    if (
      wasSubmitting.current &&
      !submitting &&
      submitFailed &&
      isString(submitError)
    ) {
      message.error({ content: submitError });
    }
    wasSubmitting.current = submitting;
  }, [submitting, submitFailed, submitError, message]);

  return null;
};

export default SubmitErrorToast;
